/*
 * @Author: xieyu7 
 * @Date: 2019-01-09 16:02:38 
 * @Last Modified by: mikey.zhaopeng
 * @Last Modified time: 2023-01-Sa 05:11:27
 */

<template>
  <div class="v-keyboard-warpper">
    <div v-if="showCancel" class="cancel-btn" @click="cancel">完成</div>
    <div class="keyboard-container">
      <div class="keyboard">
        <!-- 特殊行 -->
        <template v-if="isSecondBoardShow">
          <div class="special-line" v-for="(line, index) in SecondBoard" :key="'sboard1'+index">
            <template v-for="(key, inx) in line">
              <span
                :key="'sboard2-'+inx"
                v-text="getCaptionOfKey(key)"
                :class="getClassesOfKey(key)"
                @click="e => clickKey(e, key)"
                :style="getKeyStyle(key)"
              ></span>
            </template>
          </div>
        </template>
        <!--  普通行 -->
        <div class="line" v-for="(line, index) in keySet" :key="index">
          <template v-for="(key, inx) in line">
            <span
              :key="inx"
              v-text="getCaptionOfKey(key)"
              :class="getClassesOfKey(key)"
              @click="e => clickKey(e, key)"
              :style="getKeyStyle(key)"
            ></span>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Layouts from "./layout.js";
import isString from "lodash/isString";
import isObject from "lodash/isObject";

export default {
  props: {
    input: HTMLInputElement,
    close: Function,
    next: Function,
    previous: Function,
    updateValue: Function,
    layout: {
      // 全部键位的键盘 或者 对应的key
      type: [String, Object],
      default: "compact"
    },

    currentKeySet: {
      // 普通键盘的key
      type: String,
      default: "default"
    },
    spKeySet: {
      // 特殊键盘的key
      type: String,
      default: "off"
    },
    // 完成按钮
    showCancel: {
      type: Boolean,
      default: false
    },
    isSingleInput: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isSecondBoardShow: false
    };
  },
  watch: {
    currentKeySet: function() {
      this.isSecondBoardShow = false;
    }
  },
  computed: {
    // 普通键盘
    keySet() {
      let layout = this.getLayout();
      if (!layout) return;

      let keySet = layout[this.currentKeySet];
      if (!keySet) return;

      let res = [];

      let meta = layout["_meta"] || {};
      keySet.forEach(line => {
        let row = [];
        line.split(" ").forEach(item => {
          if (isObject(item)) {
            row.push(item);
          } else if (isString(item)) {
            // {} function key
            if (
              item.length > 2 &&
              item[0] === "{" &&
              item[item.length - 1] === "}"
            ) {
              let name = item.substring(1, item.length - 1);
              if (meta[name]) {
                row.push(meta[name]);
              } else {
                console.warn("Missing named key from meta: " + name);
              }
            } else {
              if (item === "") {
                // Placeholder
                row.push({
                  placeholder: true
                });
              } else {
                // Normal key
                row.push({
                  key: item,
                  text: item
                });
              }
            }
          }
        });
        res.push(row);
      });
      return res;
    },
    // 特殊键盘
    SecondBoard() {
      let layout = this.getLayout();
      if (!layout) return;

      let keySet = layout[this.spKeySet];
      if (!keySet) return;
      let res = [];

      let meta = layout["_meta"] || {};
      keySet.forEach(line => {
        let row = [];
        line.split(" ").forEach(item => {
          if (isObject(item)) {
            row.push(item);
          } else if (isString(item)) {
            // {} function key
            if (
              item.length > 2 &&
              item[0] === "{" &&
              item[item.length - 1] === "}"
            ) {
              let name = item.substring(1, item.length - 1);
              if (meta[name]) {
                row.push(meta[name]);
              } else {
                console.warn("Missing named key from meta: " + name);
              }
            } else {
              if (item === "") {
                // Placeholder
                row.push({
                  placeholder: true
                });
              } else {
                // Normal key
                row.push({
                  key: item,
                  text: item
                });
              }
            }
          }
        });
        res.push(row);
      });
      return res;
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },

    // 获取键盘配置
    getLayout() {
      if (isString(this.layout)) {
        return Layouts[this.layout];
      }
      return this.layout;
    },

    // 获取按键上的显示内容
    getCaptionOfKey(key) {
      return key.text || key.key || "";
    },

    // 按键的点击事件分发: 禁用键，占位键，普通键，功能键，切换键
    clickKey(e, key) {
      this.$emit("clickKeyBoard");

      if (!this.input) return;

      if (key.classes && key.classes.indexOf("notouch") > -1) return;

      if (key.placeholder) return;

      // 处理功能键点击
      if (key.func) {
        this.clickFuncKey(key);
        return;
      }
      // 处理切换键点击
      if (key.keySet) {
        this.clickKetSet(key);
        return;
      }
      this.isSecondBoardShow = false;
      // 其他普通输入按键处理
      if (this.input) {
        // 最大长度限制
        if (
          this.input.value.length < this.input.maxLength ||
          this.input.maxLength < 0
        ) {
          this.input.value += key.key;
          if (this.next) {
            this.next();
          }
          if (this.updateValue) {
            this.updateValue();
          }
        } else if (this.input.maxLength === 1) {
          this.input.value = key.key;
          if (this.next) {
            this.next();
          }
        }
      }
    },

    // 键盘布局设置切换键
    clickKetSet(key) {
      if (this.currentKeySet != key.keySet) {
        this.$emit("setKeySet", key.keySet, true);
      }
    },

    // 其他功能键 （待补充）
    clickFuncKey(key) {
      const self = this;
      switch (key.func) {
        // 关闭 由父组件传入
        case "close": {
          if (self.close) {
            self.close();
          }
          break;
        }
        // 回删处理
        case "backspace": {
          if (self.isSingleInput) {
            this.$emit("deleteInput")
          } else {
            if (self.input.value.length > 0) {
              self.input.value = "";
              if (self.updateValue) {
                self.updateValue();
              }
              break;
            } else {
              if (self.previous) {
                self.previous();
              }
              
            }
          }
          break;
        }
        // special
        case "special": {
          self.isSecondBoardShow = !self.isSecondBoardShow;
          return;
        }
        //default
        default: {
          break;
        }
      }
    },

    //根据配置classes字段处理按键class
    getClassesOfKey(key) {
      if (key.placeholder) {
        return "placeholder";
      } else {
        let classes = `key ${key.func || ""} ${key.classes || ""}`;
        if (key.keySet && this.currentKeySet === key.keySet) {
          classes += " activated";
        }
        return classes;
      }
    },

    // 根据配置，设置单独宽度
    getKeyStyle(key) {
      if (key.width) {
        return {
          flex: key.width
        };
      }
    }
  }
};
</script>


<style lang="less">
@import './font/iconfont.css';
@import './keyborad.less';
.cancel-btn {
  padding: 8px 16px;
  color: #666;
  text-align: right;
  background: #eeeeee;
  font-family: PingFangSC-Medium;
  font-size: 14px;
  color: #3880ff;
  letter-spacing: 0;
  line-height: 21px;
  font-weight: 500;
}
</style>
